import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ContactsService {

    getContacts(multiple?: boolean) {
        multiple = multiple ?? true;
        return new Promise(async (resolve) => {

            if ('contacts' in navigator && 'ContactsManager' in window) {
                try {
                    const props = ['name', 'email', 'tel', 'icon'];
                    const opts = { multiple: multiple };

                    let contacts = await (navigator as any).contacts.select(props, opts);
                    resolve(contacts);
                } catch (err) {
                    console.error('Error accessing contacts:', err);
                    resolve(err)
                }
            } else {
                console.error('Contacts Picker API not supported on this browser.');
                let contacts = [{ name: [""], email: [""], "tel": [""] }]
                resolve(contacts);
                // resolve([])


            }
        })

    }
}